import { render, staticRenderFns } from "./CustomFormRadioGroup.vue?vue&type=template&id=2e83e0a8"
import script from "./CustomFormRadioGroup.vue?vue&type=script&lang=js"
export * from "./CustomFormRadioGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports